// Photo filenames for Iron Maidens 2001
const IRON_MAIDENS_2001_PHOTOS = [
  'im0106_30813274783_c.jpg',
  'im0107_30813274703_l.jpg',
  'im0108_31586335146_z.jpg',
  'im0109_30813274623_z.jpg',
  'im0110_31586335056_c.jpg',
  'im0111_30813274523_z.jpg',
  'im0112_31586334756_c.jpg',
  'im0113_30813274463_c.jpg',
  'im0114_31586334556_c.jpg',
  'im0115_30813274383_z.jpg',
  'im0116_31586334426_c.jpg',
  'im0117_30813274253_z.jpg',
  'im0118_31586334216_z.jpg',
  'im0119_30813274193_z.jpg',
  'im0120_31586334066_z.jpg',
  'im0121_31586334016_z.jpg',
  'im0122_31250978840_z.jpg',
  'im0123_31586333876_c.jpg',
  'im0124_31250978640_z.jpg',
  'im0125_31586333626_z.jpg',
  'im0126_31250978550_z.jpg',
  'im0127_31586333486_z.jpg',
  'im0128_31476647782_z.jpg',
  'im0129_31586333296_z.jpg',
  'im0130_31476647632_z.jpg',
  'im0131_31586333116_c.jpg',
  'im0132_31476647522_z.jpg',
  'im0133_31586332876_z.jpg',
  'im0134_30781907504_z.jpg',
  'im0136_31586332696_z.jpg',
  'im0137_30781907414_c.jpg',
  'im0138_31586332516_c.jpg',
  'im0139_30781907314_z.jpg',
  'im0140_31586332236_c.jpg',
  'im0141_30781907114_z.jpg',
  'im0142_30781907054_c.jpg',
  'im0143_31586331896_c.jpg',
  'im0144_30781906994_z.jpg',
  'im0145_31586331736_c.jpg',
  'im0146_30781906944_c.jpg',
  'im0147_31586331576_z.jpg',
  'im0148_30781906824_c.jpg',
  'im0149_31586331406_z.jpg',
  'im0101_31586335766_z.jpg',
  'im0102_30813274993_z.jpg',
  'im0103_30813274933_z.jpg',
  'im0104_30813274923_z.jpg',
  'im0105_30813274873_z.jpg',
];

export default IRON_MAIDENS_2001_PHOTOS;
